/**
 * The Chinese for what the library says on its own. The library owns these words rather than
 * borrowing a surface's table: the panel keys its copy by English and the console by invented
 * keys, and the console's own "Close" is 关闭 in one place and 收起 in another, so neither
 * table could be asked for it. A surface passes only its locale.
 */
export const ZH: Record<string, string> = {
  // -- shared words
  All: '全部',
  Back: '返回',
  Cancel: '取消',
  Clear: '清除',
  Close: '关闭',
  Collapse: '收起',
  Confirm: '确认',
  'Copied!': '已复制！',
  Copy: '复制',
  Dialog: '对话框',
  Dismiss: '关闭',
  Done: '完成',
  'Enter emails': '输入邮箱地址',
  Expand: '展开',
  'Hide password': '隐藏密码',
  'Load more': '加载更多',
  'New tab': '新建标签页',
  Next: '下一步',
  'No results': '无匹配结果',
  'Search...': '搜索…',
  'Select date': '选择日期',
  'Select time': '选择时间',
  'Show password': '显示密码',
  Time: '时间',
  to: '至',
  'Try again': '重试',

  // -- calendar
  Su: '日',
  Mo: '一',
  Tu: '二',
  We: '三',
  Th: '四',
  Fr: '五',
  Sa: '六',
  'Previous month': '上个月',
  'Next month': '下个月',
  Today: '今天',
  Apply: '应用',
  'Select date range': '选择日期范围',

  // -- selects and comboboxes
  'Select...': '请选择…',
  'Close options': '收起选项',
  'Open options': '展开选项',
  'Loading options...': '正在加载选项…',
  'Searching options...': '正在搜索选项…',
  'Search all options': '搜索全部选项',
  'Showing partial results': '仅显示部分结果',
  'No matches in partial results': '部分结果中没有匹配项',
  'No matches in loaded options': '已加载的选项中没有匹配项',
  'No options loaded': '尚未加载选项',
  'No matching options found': '没有匹配的选项',
  'No options available': '没有可选项',

  // -- tag and email inputs
  'Enter values': '输入内容',
  'Add another': '继续添加',
  'Add email': '添加邮箱',
  'Add tag': '添加标签',
  'Tag input': '标签输入',
  'Remove {item}': '移除 {item}',
  'Invalid email format': '邮箱格式无效',
  'Invalid email or domain': '邮箱或域名无效',
  'Upload file': '上传文件',
  'Drop file here': '将文件拖到这里',
  'Drop files here': '将文件拖到这里',
  'Drop files here or click to browse': '将文件拖到这里，或点击选择',

  // -- tabs
  Tabs: '标签页',
  'Background activity': '后台有新动态',
  'Close {title}': '关闭 {title}',
  'Maximum of {count} tabs': '最多 {count} 个标签页',

  // -- the rest
  'More information': '更多信息',
  'Copy to clipboard': '复制到剪贴板',
}
